

export const priceFr = (number) => {
    return parseInt(number).toLocaleString().replace(/\s+/g, '.');
}